import React from "react";
import {
  ListItem as MuiListItem,
  ListItemButton,
  ListItemText,
} from "@mui/material";
import { Link } from "react-router-dom";

let ListItem = ({ primary, secondary, nested, route, isActive }) => {
  return (
    <li>
      <MuiListItem
        disablePadding
        component={Link}
        to={route}
        sx={{
          color: "inherit",
          ...(isActive
            ? {
                pointerEvents: "none",
                cursor: "default",
                borderLeft: "4px solid white",
              }
            : {}),
        }}
      >
        <ListItemButton
          sx={{
            pl: nested ? 4 : undefined,
            pt: 0.8,
            pb: 0.8,
          }}
          disableRipple
          disableTouchRipple
        >
          <ListItemText
            primary={primary}
            secondary={secondary}
            primaryTypographyProps={{
              sx: {
                textShadow: "1px 1px 2px rgba(0, 0, 0, 0.40)",
                fontSize: "1.05rem",
              },
            }}
            secondaryTypographyProps={{
              sx: {
                color: "rgba(255, 255, 255, 0.75)",
                textShadow: "2px 1px 5px rgba(0, 0, 0, 0.50)",
                fontSize: "0.9rem",
              },
            }}
          />
        </ListItemButton>
      </MuiListItem>
    </li>
  );
};

ListItem = React.memo(ListItem);

export default ListItem;
